import * as Shared from '@shared/lib';
import { UserData } from '@stores';

export function formatStat(key: string, value: any) {
  const percent = [
    'ElementalResistances',
    'activeCritMultiplier',
    'multiTargetChance',
    'abilityEfficiency',
    'activeCritChance',
    'armorPenetration',
    'abilityCooldown',
    'abilityDuration',
    'abilityStrength',
    'dodgeChance',
    'critChance',
    'critResist',
  ];
  const isPercent = percent.some(p => key.includes(p));
  if (isPercent) return `${(value * 100).toFixed(2)}%`;

  if (key === 'critMultiplier') return `${value.toFixed(2)}x`;
  if (key === 'damageInterval') return `${(1000 / value).toFixed(2)}/s`;
  if (key === 'reloadDuration') return `${(value / 1000).toFixed(2)}s`;
  if (key === 'Shield.regenRate') return `${value.toFixed(2)}/s`;
  if (key === 'Shield.timeout') return `${(value / 1000).toFixed(2)}s`;

  return value.toFixed(0);
}

export function getModifiedStats(data: UserData, id: string, type: 'chassis' | 'weapon') {
  const target = type === 'chassis'
    ? data.chassis.find(c => c.id === id)
    : data.weapons.find(w => w.id === id);
  if (!target) return null;

  const baseData = type === 'chassis'
    ? Shared.chassisData.find((c) => c.key === target.key)
    : Shared.weaponsData.find((w) => w.key === target.key);
  if (!baseData) return null;

  const modIds = type === 'chassis'
    ? data.chassis.find(c => c.id === id)?.mods.map(m => m.modId)
    : data.weapons.find(w => w.id === id)?.mods.map(m => m.modId);
  if (!modIds) return null;

  const mods = data.mods.filter(m => modIds.includes(m.id));
  return Shared.modifyStats(baseData.stats, mods, Shared.modData);
}